// extracted by mini-css-extract-plugin
export var card = "_8m-1";
export var container = "_8m-0";